import * as All$SolvuuRoot0 from "solvuu-root0/./all.bs.js";
import * as Csv$SolvuuRoot0 from "solvuu-root0/./csv.bs.js";
import * as Fmt$SolvuuRoot0 from "solvuu-root0/./fmt.bs.js";
import * as Lang$SolvuuApi0 from "./lang.bs.js";
import * as Fasta$SolvuuRoot0 from "solvuu-root0/./fasta.bs.js";
import * as Stats$SolvuuRoot0 from "solvuu-root0/./stats.bs.js";
import * as T_test$SolvuuRoot0 from "solvuu-root0/./t_test.bs.js";
import * as Heatmap$SolvuuRoot0 from "solvuu-root0/./heatmap.bs.js";
import * as Box_plot$SolvuuRoot0 from "solvuu-root0/./box_plot.bs.js";
import * as Dot_plot$SolvuuRoot0 from "solvuu-root0/./dot_plot.bs.js";
import * as Bar_chart$SolvuuRoot0 from "solvuu-root0/./bar_chart.bs.js";
import * as Histogram$SolvuuRoot0 from "solvuu-root0/./histogram.bs.js";
import * as Area_chart$SolvuuRoot0 from "solvuu-root0/./area_chart.bs.js";
import * as Line_chart$SolvuuRoot0 from "solvuu-root0/./line_chart.bs.js";
import * as Donut_chart$SolvuuRoot0 from "solvuu-root0/./donut_chart.bs.js";
import * as Hexbin_plot$SolvuuRoot0 from "solvuu-root0/./hexbin_plot.bs.js";
import * as Krona_chart$SolvuuRoot0 from "solvuu-root0/./krona_chart.bs.js";
import * as Violin_plot$SolvuuRoot0 from "solvuu-root0/./violin_plot.bs.js";
import * as Bubble_chart$SolvuuRoot0 from "solvuu-root0/./bubble_chart.bs.js";
import * as Scatter_plot$SolvuuRoot0 from "solvuu-root0/./scatter_plot.bs.js";
import * as Venn_diagram$SolvuuRoot0 from "solvuu-root0/./venn_diagram.bs.js";
import * as Volcano_plot$SolvuuRoot0 from "solvuu-root0/./volcano_plot.bs.js";
import * as Kernel_density$SolvuuRoot0 from "solvuu-root0/./kernel_density.bs.js";
import * as Scatter_matrix$SolvuuRoot0 from "solvuu-root0/./scatter_matrix.bs.js";
import * as Summary_statistics$SolvuuRoot0 from "solvuu-root0/./summary_statistics.bs.js";
import * as Parallel_coordinates$SolvuuRoot0 from "solvuu-root0/./parallel_coordinates.bs.js";
import * as Principal_coordinates$SolvuuRoot0 from "solvuu-root0/./principal_coordinates.bs.js";
import * as Quantile_quantile_plot$SolvuuRoot0 from "solvuu-root0/./quantile_quantile_plot.bs.js";
var compare = Lang$SolvuuApi0.Var.compare;
var of_string = Lang$SolvuuApi0.Var.Exn.of_string;

function of_list(x) {
  return x;
}

var include = All$SolvuuRoot0.Make({
  compare: compare,
  of_string: of_string,
  of_list: of_list
});
var partial_arg = Lang$SolvuuApi0.Record.Param;
var partial_arg$1 = Area_chart$SolvuuRoot0.Make;

var Area_chart = function (param) {
  return partial_arg$1(partial_arg, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$2 = Lang$SolvuuApi0.Record.Param;
var partial_arg$3 = Bar_chart$SolvuuRoot0.Make;

var Bar_chart = function (param) {
  return partial_arg$3(partial_arg$2, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$4 = Lang$SolvuuApi0.Record.Param;
var partial_arg$5 = Box_plot$SolvuuRoot0.Make;

var Box_plot = function (param) {
  return partial_arg$5(partial_arg$4, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$6 = Lang$SolvuuApi0.Record.Param;
var partial_arg$7 = Bubble_chart$SolvuuRoot0.Make;

var Bubble_chart = function (param) {
  return partial_arg$7(partial_arg$6, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$8 = Lang$SolvuuApi0.Record.Param;
var partial_arg$9 = Donut_chart$SolvuuRoot0.Make;

var Donut_chart = function (param) {
  return partial_arg$9(partial_arg$8, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$10 = Lang$SolvuuApi0.Record.Param;
var partial_arg$11 = Dot_plot$SolvuuRoot0.Make;

var Dot_plot = function (param) {
  return partial_arg$11(partial_arg$10, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$12 = Lang$SolvuuApi0.Record.Param;
var partial_arg$13 = Heatmap$SolvuuRoot0.Make;

var Heatmap = function (param) {
  return partial_arg$13(partial_arg$12, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$14 = Lang$SolvuuApi0.Record.Param;
var partial_arg$15 = Hexbin_plot$SolvuuRoot0.Make;

var Hexbin_plot = function (param) {
  return partial_arg$15(partial_arg$14, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$16 = Lang$SolvuuApi0.Record.Param;
var partial_arg$17 = Histogram$SolvuuRoot0.Make;

var Histogram = function (param) {
  return partial_arg$17(partial_arg$16, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$18 = Lang$SolvuuApi0.Record.Param;
var partial_arg$19 = Kernel_density$SolvuuRoot0.Make;

var Kernel_density = function (param) {
  return partial_arg$19(partial_arg$18, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$20 = Lang$SolvuuApi0.Record.Param;
var partial_arg$21 = Krona_chart$SolvuuRoot0.Make;

var Krona_chart = function (param) {
  return partial_arg$21(partial_arg$20, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$22 = Lang$SolvuuApi0.Record.Param;
var partial_arg$23 = Line_chart$SolvuuRoot0.Make;

var Line_chart = function (param) {
  return partial_arg$23(partial_arg$22, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$24 = Lang$SolvuuApi0.Record.Param;
var partial_arg$25 = Parallel_coordinates$SolvuuRoot0.Make;

var Parallel_coordinates = function (param) {
  return partial_arg$25(partial_arg$24, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$26 = Lang$SolvuuApi0.Record.Param;
var partial_arg$27 = Principal_coordinates$SolvuuRoot0.Make;

var Principal_coordinates = function (param) {
  return partial_arg$27(partial_arg$26, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$28 = Lang$SolvuuApi0.Record.Param;
var partial_arg$29 = Quantile_quantile_plot$SolvuuRoot0.Make;

var Quantile_quantile_plot = function (param) {
  return partial_arg$29(partial_arg$28, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$30 = Lang$SolvuuApi0.Record.Param;
var partial_arg$31 = Scatter_plot$SolvuuRoot0.Make;

var Scatter_plot = function (param) {
  return partial_arg$31(partial_arg$30, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$32 = Lang$SolvuuApi0.Record.Param;
var partial_arg$33 = Scatter_matrix$SolvuuRoot0.Make;

var Scatter_matrix = function (param) {
  return partial_arg$33(partial_arg$32, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$34 = Lang$SolvuuApi0.Record.Param;
var partial_arg$35 = Stats$SolvuuRoot0.Make;

var Stats = function (param) {
  return partial_arg$35(partial_arg$34, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$36 = Lang$SolvuuApi0.Record.Param;
var partial_arg$37 = Summary_statistics$SolvuuRoot0.Make;

var Summary_statistics = function (param) {
  return partial_arg$37(partial_arg$36, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$38 = Lang$SolvuuApi0.Record.Param;
var partial_arg$39 = T_test$SolvuuRoot0.Make;

var T_test = function (param) {
  return partial_arg$39(partial_arg$38, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$40 = Lang$SolvuuApi0.Record.Param;
var partial_arg$41 = Venn_diagram$SolvuuRoot0.Make;

var Venn_diagram = function (param) {
  return partial_arg$41(partial_arg$40, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$42 = Lang$SolvuuApi0.Record.Param;
var partial_arg$43 = Violin_plot$SolvuuRoot0.Make;

var Violin_plot = function (param) {
  return partial_arg$43(partial_arg$42, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var partial_arg$44 = Lang$SolvuuApi0.Record.Param;
var partial_arg$45 = Volcano_plot$SolvuuRoot0.Make;

var Volcano_plot = function (param) {
  return partial_arg$45(partial_arg$44, param);
}({
  to_string: Lang$SolvuuApi0.Label.to_string,
  named_exn: Lang$SolvuuApi0.Label.named_exn,
  positional_exn: Lang$SolvuuApi0.Label.positional_exn
});

var all = include.all;
var neg = include.neg;
var fneg = include.fneg;
var not = include.not;
var and_ = include.and_;
var or_ = include.or_;
var plus = include.plus;
var minus = include.minus;
var multiply = include.multiply;
var div = include.div;
var plus_float = include.plus_float;
var minus_float = include.minus_float;
var multiply_float = include.multiply_float;
var fdiv = include.fdiv;
var equal = include.equal;
var not_equal = include.not_equal;
var lt = include.lt;
var lte = include.lte;
var gt = include.gt;
var gte = include.gte;
var equal_float = include.equal_float;
var not_equal_float = include.not_equal_float;
var lt_float = include.lt_float;
var lte_float = include.lte_float;
var gt_float = include.gt_float;
var gte_float = include.gte_float;
var equal_string = include.equal_string;
var not_equal_string = include.not_equal_string;
var lt_string = include.lt_string;
var lte_string = include.lte_string;
var gt_string = include.gt_string;
var gte_string = include.gte_string;
var append = include.append;
var identity = include.identity;
var length = include.length;
var concat = include.concat;
var map = include.map;
var mapi = include.mapi;
var filter = include.filter;
var fold = include.fold;
var hd = include.hd;
var tl = include.tl;
var empty = include.empty;
var $$int = include.$$int;
var bool = include.bool;
var $$char = include.$$char;
var $$float = include.$$float;
var string = include.string;
var fastq = include.fastq;
var print_fastq = include.print_fastq;
var sam = include.sam;
var fasta = include.fasta;
var csv = include.csv;
var gunzip = include.gunzip;
var maybe = include.maybe;
var base64_decode = include.base64_decode;
var biom = include.biom;
var csv_of_biom = include.csv_of_biom;
var indexed_dataframe = include.indexed_dataframe;
var newick = include.newick;
var html = include.html;
var png = include.png;
var bam = include.bam;
var bam_index = include.bam_index;
var fasta_index = include.fasta_index;
var bed = include.bed;
var big_bed = include.big_bed;
var big_wig = include.big_wig;
var gtf = include.gtf;
var gff = include.gff;
var vcf = include.vcf;
var vcf_index = include.vcf_index;
var gzip = include.gzip;
var print_int = include.print_int;
var print_bool = include.print_bool;
var print_string = include.print_string;
var print_float = include.print_float;
var print_char = include.print_char;
var print_solvuu = include.print_solvuu;
var print_maybe = include.print_maybe;
var print_csv = include.print_csv;
var uri = include.uri;
var stats = include.stats;
var histogram = include.histogram;
var t_test = include.t_test;
var cat = include.cat;
var echo = include.echo;
var ls = include.ls;
var date = include.date;
var bigbed = include.bigbed;
var bigwig = include.bigwig;
var ascii = include.ascii;
var bash = include.bash;
var cram = include.cram;
var cram_index = include.cram_index;
var bytes = include.bytes;
var json = include.json;
var qza = include.qza;
var multiQC = include.multiQC;
var rdata = include.rdata;
var solvuu = include.solvuu;
var solvuu_json = include.solvuu_json;
var solvuu_runtime_json = include.solvuu_runtime_json;
var solvuu_eval_json = include.solvuu_eval_json;
var solvuu_type = include.solvuu_type;
var solvuu_type_json = include.solvuu_type_json;
var solvuu_fmt = include.solvuu_fmt;
var solvuu_fmt_json = include.solvuu_fmt_json;
var solvuu_bigdata = include.solvuu_bigdata;
var solvuu_dataframe = include.solvuu_dataframe;
var area_chart = include.area_chart;
var bar_chart = include.bar_chart;
var box_plot = include.box_plot;
var bubble_chart = include.bubble_chart;
var donut_chart = include.donut_chart;
var dot_plot = include.dot_plot;
var heat_map = include.heat_map;
var hexbin_plot = include.hexbin_plot;
var kernel_density = include.kernel_density;
var krona_chart = include.krona_chart;
var line_chart = include.line_chart;
var parallel_coordinates = include.parallel_coordinates;
var principal_coordinates = include.principal_coordinates;
var quantile_quantile_plot = include.quantile_quantile_plot;
var scatter_plot = include.scatter_plot;
var scatter_matrix = include.scatter_matrix;
var summary_statistics = include.summary_statistics;
var venn_diagram = include.venn_diagram;
var violin_plot = include.violin_plot;
var volcano_plot = include.volcano_plot;
var rnaseq = include.rnaseq;
var paired_fastq_to_unmapped_bam = include.paired_fastq_to_unmapped_bam;
var whole_genome_germline_single_sample = include.whole_genome_germline_single_sample;
var exome_germline_single_sample = include.exome_germline_single_sample;
var fastq_to_ubam = include.fastq_to_ubam;
var celmatix_merge_bam_alignment = include.celmatix_merge_bam_alignment;
var celmatix_mark_duplicates = include.celmatix_mark_duplicates;
var celmatix_bqsr_table = include.celmatix_bqsr_table;
var celmatix_downsample_ubam = include.celmatix_downsample_ubam;
var fastq_stats = include.fastq_stats;
var Csv = Csv$SolvuuRoot0;
var Fasta = Fasta$SolvuuRoot0;
var Fmt = Fmt$SolvuuRoot0;
var $$let = Stats.T;
var Stats_Record_param = Stats.Record_param;
var Stats_Label = Stats.Label;
var Stats_Arg = Stats.Arg;
var Stats_T = {
  Const: $$let.Const,
  $$Error: $$let.$$Error,
  to_record: $$let.to_record,
  of_record: $$let.of_record
};
var Stats$1 = {
  Record_param: Stats_Record_param,
  Label: Stats_Label,
  Arg: Stats_Arg,
  T: Stats_T
};
export { all, neg, fneg, not, and_, or_, plus, minus, multiply, div, plus_float, minus_float, multiply_float, fdiv, equal, not_equal, lt, lte, gt, gte, equal_float, not_equal_float, lt_float, lte_float, gt_float, gte_float, equal_string, not_equal_string, lt_string, lte_string, gt_string, gte_string, append, identity, length, concat, map, mapi, filter, fold, hd, tl, empty, $$int, bool, $$char, $$float, string, fastq, print_fastq, sam, fasta, csv, gunzip, maybe, base64_decode, biom, csv_of_biom, indexed_dataframe, newick, html, png, bam, bam_index, fasta_index, bed, big_bed, big_wig, gtf, gff, vcf, vcf_index, gzip, print_int, print_bool, print_string, print_float, print_char, print_solvuu, print_maybe, print_csv, uri, stats, histogram, t_test, cat, echo, ls, date, bigbed, bigwig, ascii, bash, cram, cram_index, bytes, json, qza, multiQC, rdata, solvuu, solvuu_json, solvuu_runtime_json, solvuu_eval_json, solvuu_type, solvuu_type_json, solvuu_fmt, solvuu_fmt_json, solvuu_bigdata, solvuu_dataframe, area_chart, bar_chart, box_plot, bubble_chart, donut_chart, dot_plot, heat_map, hexbin_plot, kernel_density, krona_chart, line_chart, parallel_coordinates, principal_coordinates, quantile_quantile_plot, scatter_plot, scatter_matrix, summary_statistics, venn_diagram, violin_plot, volcano_plot, rnaseq, paired_fastq_to_unmapped_bam, whole_genome_germline_single_sample, exome_germline_single_sample, fastq_to_ubam, celmatix_merge_bam_alignment, celmatix_mark_duplicates, celmatix_bqsr_table, celmatix_downsample_ubam, fastq_stats, Area_chart, Bar_chart, Box_plot, Bubble_chart, Csv, Donut_chart, Dot_plot, Fasta, Fmt, Heatmap, Hexbin_plot, Histogram, Kernel_density, Krona_chart, Line_chart, Parallel_coordinates, Principal_coordinates, Quantile_quantile_plot, Scatter_plot, Scatter_matrix, Stats$1 as Stats, Summary_statistics, T_test, Venn_diagram, Violin_plot, Volcano_plot };
/* include Not a pure module */